import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// import HighchartsReact from 'highcharts-react-official';
// import Highcharts from 'highcharts/es-modules/masters/highcharts.src.js';

import { Button, Empty, Table, Typography } from 'antd';

import { isEqual } from 'lodash';

import {
  fetchLeaderboard,
  fetchMetrics,
  LeaderboardScoresType,
  METRICS_TYPES,
  recomputeLeaderboard,
  selectors,
} from 'state';
import { LoadingScreen } from 'components';
import { formatters, useModal } from 'services';
import RefreshAssetEodModal from '../../AdminDashboard/Data/AssetsTab/RefreshAssetEodModal';
import EditWeightsModal from './editWeightsModal';
import { leaderbordScores } from '../../../state/app/selectors';
import type { TableColumnsType as ColumnsType } from 'antd';

const LeaderBoard: React.FC = () => {
  const dispatch = useDispatch();
  const session = useSelector(selectors.activeSession);
  let scores = useSelector(selectors.leaderbordScores);
  console.log(scores);

  const [editWeightsModal, showEditWeightsModal] = useModal(EditWeightsModal);

  useEffect(() => {
    dispatch(fetchLeaderboard({ session_id: session.id }));
  }, [dispatch]);
  // if (metrics_fetching || !metrics_fetched) return <LoadingScreen />;

  const metricTypes = useMemo(() => {
    const first = scores?.[0];
    if (!first) return [];

    return Array.from(new Set(first.scores.map(s => s.metric_type)));
  }, [scores]);

  if (metricTypes.length === 0) {
    scores = [];
  }

  const columns: ColumnsType<LeaderboardScoresType> = useMemo(() => {
    const base: ColumnsType<LeaderboardScoresType> = [
      {
        title: 'Player',
        dataIndex: 'player_name',
        key: 'player_name',
      },
      {
        title: 'Total Score',
        dataIndex: 'total_score',
        key: 'total_score',
        render: (val: number) => formatters.percent2Digit(val),
        sorter: (a, b) => a.total_score - b.total_score,
        defaultSortOrder: 'descend',
      },
    ];

    const metricCols: ColumnsType<LeaderboardScoresType> = metricTypes.map(
      metricType => ({
        title: METRICS_TYPES[metricType] ?? `Metric ${metricType}`,
        key: `metric_${metricType}`,
        // we don't need dataIndex; we derive value from record.scores
        render: (_: unknown, record: LeaderboardScoresType) => {
          const metric = record.scores.find(s => s.metric_type === metricType);
          if (!metric) return '-';
          return formatters.percent2Digit(metric.score);
        },
      })
    );

    return [...base, ...metricCols];
  }, [metricTypes]);

  const noData = (
    <Empty
      description={
        <Typography.Text type={'secondary'}>
          {'Leaderboard not available yet.'}
        </Typography.Text>
      }
    />
  );

  const noDataBehaviour = {
    emptyText: noData,
  };

  return (
    <div>
      <Typography.Title level={4}>Leaderboard</Typography.Title>
      <Table
        dataSource={scores}
        locale={noDataBehaviour}
        columns={columns}
        bordered
        footer={() => (
          <div>
            <Button onClick={() => showEditWeightsModal({})}>
              Edit Weights
            </Button>
            <Button
              onClick={() =>
                dispatch(recomputeLeaderboard({ session_id: session.id }))
              }
              style={{ marginLeft: 10 }}
            >
              Recompute
            </Button>
          </div>
        )}
      />
      {editWeightsModal}
    </div>
  );
};

export default LeaderBoard;
